module.exports = __webpack_public_path__ + "img/Loader-3.cda45b66.png";